import { VSheet } from 'vuetify/lib/components/VSheet';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.client.settings.announcement)?_c(VSheet,{staticClass:"announcement text-uppercase mb-1 mt-1 font-weight-bold",attrs:{"color":"#B31013"}},[_c('marquee',{staticClass:"mt-2",attrs:{"direction":"left"}},[_vm._v(_vm._s(_vm.client.settings.announcement))])],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }